import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateAdminSettingsService } from "@Services/UserService";
import { React_Query_Keys } from "@utils/constants";
import { isAxiosError } from "axios";
import ShowToast from "@utils/showToast";

const useUpdateAdminSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateAdminSettingsService,
    mutationKey: [React_Query_Keys.UPDATE_SETTINGS],
    onError: (error: unknown) => {
      if (isAxiosError(error)) {
        ShowToast(error.response?.data.message, "error");
      }
    },
    onSuccess: () => {
      ShowToast("Settings Updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: [React_Query_Keys.FETCH_SETTINGS] });
    }
  });
};

export default useUpdateAdminSettings;
